import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'viewAllSpacesButtonLabel'
	| 'chatInputActionsButtonsTooltip'
	| 'chatInputActionsButtonsCloseTooltip'
	| 'mentionTypeAheadButtonLabel'
	| 'linkTypeAheadButtonLabel'
	| 'addContentButtonLabel'
	| 'addMoreFormattingButtonLabel'
	| 'deepResearchButtonLabel'
	| 'conciergeButtonLabel'
	| 'conciergeBetaLabel'
	| 'deepResearchButtonAgentMentionDisabledTooltip'
	| 'addCurrentPageAsContextDisabledTooltip'
	| 'discoverSkillsButtonLabel'
	| 'discoverSkillsButtonDisabledTooltip'
	| 'discoverSkillsButtonAgentMentionDisabledTooltip';

export const messages: Record<
	MessageKeys,
	{ id: string; defaultMessage: string; description?: string }
> = defineMessages({
	viewAllSpacesButtonLabel: {
		id: 'conversation-assistant-chat-prompt-input.common.chat-input-action-buttons.viewAllSpacesButtonLabel',
		defaultMessage: 'View all Rovo spaces',
		description: 'Label for the view all spaces button in the chat input actions menu',
	},
	chatInputActionsButtonsTooltip: {
		id: 'ai-mate.chat-input.open-chat-input-buttons-tooltip',
		defaultMessage: 'Add',
		description: 'Tooltip for Add a resource menu button',
	},
	chatInputActionsButtonsCloseTooltip: {
		id: 'ai-mate.chat-input.close-chat-input-buttons-tooltip',
		defaultMessage: 'Close',
		description:
			'Tooltip for the Add a resource menu button when the menu is open, showing a close icon',
	},
	mentionTypeAheadButtonLabel: {
		id: 'ai-mate.chat-input.mention-type-ahead-button.label',
		defaultMessage: 'Mention someone',
		description: 'Label for the mention type ahead button',
	},
	linkTypeAheadButtonLabel: {
		id: 'ai-mate.chat-input.link-type-ahead-button.label',
		defaultMessage: 'Add a link',
		description: 'Label for the link type ahead button',
	},
	addContentButtonLabel: {
		id: 'ai-mate.chat-input.add-content-button.label',
		defaultMessage: "Use what you're viewing as context",
		description: 'Label for the add current page as context button',
	},
	addMoreFormattingButtonLabel: {
		id: 'ai-mate.chat-input.add-more-formatting-button.label',
		defaultMessage: 'More formatting',
		description: 'Label for the more formatting button',
	},
	deepResearchButtonLabel: {
		id: 'ai-mate.chat-input.deep-research-button.label',
		defaultMessage: 'Deep research',
		description: 'Label for the deep research button in the chat input actions menu',
	},
	conciergeButtonLabel: {
		id: 'ai-mate.chat-input.concierge-button.label',
		defaultMessage: 'Concierge',
		description: 'Label for the Concierge button in the chat input actions menu',
	},
	conciergeBetaLabel: {
		id: 'ai-mate.chat-input.concierge-button.beta-label',
		defaultMessage: 'Beta',
		description: 'Beta badge shown next to Concierge in the chat input actions menu',
	},
	deepResearchButtonAgentMentionDisabledTooltip: {
		id: 'ai-mate.chat-input.deep-research-button.agent-mention-disabled-tooltip',
		defaultMessage: 'Not available with mentioned agents',
		description:
			'Tooltip for the deep research button when disabled because an agent is @-mentioned in the chat input',
	},
	addCurrentPageAsContextDisabledTooltip: {
		id: 'ai-mate.chat-input.add-current-page-as-context-disabled-tooltip',
		defaultMessage: "This page isn't supported yet",
		description: 'Tooltip for the add current page as context button when disabled',
	},
	discoverSkillsButtonLabel: {
		id: 'ai-mate.chat-input.discover-skills-button.label',
		defaultMessage: 'View all skills',
		description: 'Label for the view all skills button',
	},
	discoverSkillsButtonDisabledTooltip: {
		id: 'ai-mate.chat-input.discover-skills-button.disabled-tooltip',
		defaultMessage: "You're already using a skill",
		description:
			'Tooltip for the discover skills button when disabled because a skill is already in the prompt',
	},
	discoverSkillsButtonAgentMentionDisabledTooltip: {
		id: 'ai-mate.chat-input.discover-skills-button.agent-mention-disabled-tooltip',
		defaultMessage: 'Not available with mentioned agents',
		description:
			'Tooltip for the discover skills button when disabled because an agent is @-mentioned in the chat input',
	},
});
